import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const TestGuidelines = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2, backgroundColor: "#f5f5f5" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        {t("Manual Testing Guidelines")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {t("Please ensure accurate values for optimal recommendations:")}
      </Typography>
      <Box component="ul" sx={{ pl: 2, m: 0 }}>
        <Typography component="li" variant="body2" color="text.secondary">
          {t("pH values should be between 0-14")}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t("Nutrient levels in kg/ha based on laboratory analysis")}
        </Typography>
        <Typography component="li" variant="body2" color="text.secondary">
          {t("Organic carbon typically ranges from 0.1-2.0%")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default TestGuidelines;
